import { copyToClipboard } from '@/shared/utils/clipboard'

export const PLAY_CANONICAL_URL = 'https://play.united-square.com/'

export type ShareResult = 'sent' | 'copied' | 'unavailable' | 'cancelled'

export const SHARE_MESSAGE_KEYS = {
  sent: 'home.shareSent',
  copied: 'home.shareCopied',
  unavailable: 'home.shareUnavailable',
} as const

export async function shareApp(data: ShareData & { url: string }): Promise<ShareResult> {
  if (navigator.share) {
    try {
      await navigator.share(data)
      return 'sent'
    } catch (error) {
      if ((error as { name?: string } | null)?.name === 'AbortError') return 'cancelled'
    }
  }

  return (await copyToClipboard(data.url)) ? 'copied' : 'unavailable'
}
